import styles from './VerticalSystemTabs.module.scss';

import cx from 'classnames';
import React from 'react';
import { TextV2 } from 'components/TextV2/TextV2';
import { useScrollableElement } from 'hooks/useScrollableElement';
import { useVerticalSystemContext } from '../VerticalSystemContext/VerticalSystemContext';

export const VerticalSystemTabs = () => {
  const { tabItems, activeTabItem, setActiveTabItem } = useVerticalSystemContext();
  const scrollableElementProps = useScrollableElement<HTMLDivElement>('x');
  const withScrollber = scrollableElementProps.role === 'scrollbar';

  return (
    <div className={cx(styles.root, withScrollber && styles.withScrollber)} {...scrollableElementProps}>
      <div role="tablist" className={styles.tabList}>
        {tabItems.map(tab => {
          const isTabActive = tab.title === activeTabItem?.title;
          return (
            <button
              aria-controls={`panel-${tab.id}`}
              aria-selected={isTabActive}
              className={styles.button}
              id={`tab-${tab.id}`}
              key={tab.title}
              role="tab"
              type="button"
              onClick={() => setActiveTabItem(tab)}
            >
              <TextV2 variant={isTabActive ? 'modern-body-medium' : 'modern-body'} value={tab.title} />
            </button>
          );
        })}
      </div>
    </div>
  );
};
